module.exports = __webpack_public_path__ + "static/media/Tidal.b858d172.svg";